import { Tag } from '@ontruck/orc';

const t = { high_prio: 'High\u00A0prio' };

const HighPrioTag = () => {
  return (
    <Tag skin="modernRed" weight="bold" textTransform="uppercase">
      {t.high_prio}
    </Tag>
  );
};

export default HighPrioTag;
